import axios from "axios";
export const getWxLoginUrl = () => {
  return axios.request({
    url: "/api/sso/login/qrcode",
    method: "get"
  });
};
export const wxLogin = data => {
  return axios.request({
    url: "/api/sso/wechat/login",
    method: "post",
    data
  });
};
export const qrCodeStatus = data => {
  return axios.request({
    url: "/api/sso/update/wechatLoginStatus",
    method: "post",
    data
  });
};
export const uuidCheck = uuid => {
  return axios.request({
    url: "/api/sso/check",
    method: "get",
    params: {
      uuid
    }
  });
};
export const pushWxMsg = async (uuid, userId) => {
  return axios.request({
    url: "/api/sso/sendWechatInfo",
    method: "post",
    data: {
      uuid,
      userId
    }
  });
};